import React from 'react';

const Pagination = ({ 
  page, 
  size, 
  total,
  totalPages, 
  currentPageItems,
  handlePageChange, 
  handleJumpPages, 
  setPageListItems, 
  getPageNumbers 
}) => {
  return (
    <div className="card-footer d-flex justify-content-between align-items-center">
      <div className="text-muted">
        Showing {currentPageItems} of {total} records
      </div>
      <div className="d-flex align-items-center">
        <div className="dropdown me-2">
          <button className="btn dropdown-toggle" data-bs-toggle="dropdown">
            <span id="page-count" className="me-1">{size}</span>
            <span>records</span>
          </button>
          <div className="dropdown-menu">
            {[2, 4, 8, 10, 20, 50, 100].map((option) => (
              <button
                key={option}
                className="dropdown-item"
                onClick={setPageListItems}
                data-value={option}
              >
                {option} records
              </button>
            ))}
          </div>
        </div>
        <ul className="pagination m-0">
          <li className={`page-item ${page === 0 ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => handleJumpPages('backward')} title="Back 5 pages">
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="icon icon-1">
                <path d="M18 6L12 12L18 18" />
                <path d="M12 6L6 12L12 18" />
              </svg>
            </button>
          </li>
          <li className={`page-item ${page === 0 ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => handlePageChange(page - 1)}>
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="icon icon-1">
                <path d="M15 6l-6 6l6 6" />
              </svg>
            </button>
          </li>
          {getPageNumbers().map((pageNum, idx) => (
            pageNum === '...' ? (
              <li key={`ellipsis-${idx}`} className="page-item disabled">
                <span className="page-link">...</span>
              </li>
            ) : (
              <li key={pageNum} className={`page-item ${pageNum === page ? 'active' : ''}`}>
                <button className="page-link" onClick={() => handlePageChange(pageNum)}>
                  {pageNum + 1}
                </button>
              </li>
            )
          ))}
          <li className={`page-item ${page + 1 === totalPages ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => handlePageChange(page + 1)}>
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="icon icon-1">
                <path d="M9 6l6 6l-6 6" />
              </svg>
            </button>
          </li>
          <li className={`page-item ${page >= totalPages - 1 ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => handleJumpPages('forward')} title="Forward 5 pages">
              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="icon icon-1">
                <path d="M6 6L12 12L6 18" />
                <path d="M12 6L18 12L12 18" />
              </svg>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Pagination; 